<template>
 <div class="homepage">
   <NavbarComponent :loadingStatus="loading">Navigator Datasource Project - {{project_name}}</NavbarComponent>
   <br>
<section>
<div class="container is-fluid">
 <b-tabs  visible="!verificationEditMode" v-model="activeTab" @change="onTabChange" type="is-boxed">
            <b-tab-item label="Original Datasources">
<p>Import list of datasources (Meter setup file from Navigator or csv with "Datasource" column to verify with new MSIB files.</p>

           <b-field>
            <b-upload v-model="dropFiles_originaldatasources"
      
                drag-drop>
                <section class="section">
<div class="content has-text-centered">
    <p>
        <b-icon
            icon="upload"
            size="is-large">
        </b-icon>
    </p>
    <p>Drop your files here or click to upload {{dropFiles_originaldatasources.name}}</p>
</div>
                </section>
            </b-upload>
        </b-field>

	       <b-field label="File Type">
            <b-select v-model="originaldatasourceFileType">
                <option value="meter_setup_xlsx">Meter Setup XLSX</option>
               <option value="datasource_list_csv_utf8">Datasource List CSV UTF-8</option>
            </b-select>
        </b-field>

   <b-field grouped group-multiline>
               <p class="control"><b-button  label="Upload File" type="is-primary" @click="uploadOriginalDatasources"></b-button></p>
                       <p class="control"> <b-button label="Delete" type="is-dark" @click="deleteOriginalDatasources"></b-button></p>
    </b-field>
                <br>
                <b-table
            :data="originaldatasources_data"
            :columns="originaldatasources_columns"
            paginated :per-page="paginationPerpage">
            </b-table>
            </b-tab-item>

            <b-tab-item label="MSIB Original Files">
                <p>Import MSIB files (multiple allowed) of either EDEs or a discovery or site explorer file. Used for comparing old datasources with new datasources, as well as generating culled MSIB files with the new datasources and datasources in NDMT file.</p>

                   <b-field>
            <b-upload v-model="dropFiles_msibdatasources"
                 multiple
                drag-drop>
                <section class="section">
<div class="content has-text-centered">
    <p>
        <b-icon
            icon="upload"
            size="is-large">
        </b-icon>
    </p>
    <p>Drop your files here or click to upload</p>
</div>
                </section>
            </b-upload>
        </b-field>

        	       <b-field label="File Type">
            <b-select v-model="msibdatasourcesFileType">
                <option value="EDE-unedited">EDE unedited</option>
               <option value="Discovery">Discovery</option>
            </b-select>
        </b-field>

      

        <div class="tags">
            <span v-for="(file, index) in dropFiles_msibdatasources"
                :key="index"
                class="tag is-primary" >
                {{file.name}}
                <button class="delete is-small"
type="button"
@click="deleteDropFile(index)">
                </button>
            </span>
        </div>




   <b-field grouped group-multiline>
               <p class="control"><b-button  label="Upload File" type="is-primary" @click="uploadMSIBdatasources"></b-button></p>
                       <p class="control"> <b-button label="Delete" type="is-dark" @click="deleteMSIBdatasources"></b-button></p>
    </b-field>
        <b-field label="Uploaded Files">
                   <div class="tags">
            <span v-for="(file, index) in msib_original_files"
                :key="index"
                class="tag is-primary" >
                {{file.name}}
            </span>
        </div>
            </b-field>
                  <b-table
            :data="msibdatasources_data"
            :columns="msibdatasources_columns"
            paginated :per-page="paginationPerpage">
            </b-table>
            </b-tab-item>

            <b-tab-item label="NDMT Original File" >
        <p>Upload NDMT file export. Used to generate modified NDMT file with new datasources. Datasources in this file are also used for generating culled MSIB files. </p>
                  <b-field>
            <b-upload v-model="dropFiles_ndmt_original_file"
                
                drag-drop>
                <section class="section">
<div class="content has-text-centered">
    <p>
        <b-icon
            icon="upload"
            size="is-large">
        </b-icon>
    </p>
    
    <p>Drop your files here or click to upload {{dropFiles_ndmt_original_file.name}}</p>
</div>
                </section>
            </b-upload>
        </b-field>


   <b-field grouped group-multiline>
               <p class="control"><b-button  label="Upload File" type="is-primary" @click="uploadNDMTOriginalFile"></b-button></p>
                       <p class="control"> <b-button label="Delete" type="is-dark" @click="deleteNDMTOriginalFile"></b-button></p>
    </b-field>

                <br>
                <b-field label="Uploaded file">
               <p v-for="file in ndmt_original_file_info" :key="file.name">    {{ file.name }}  </p>
                </b-field>


                <b-table
            :data="ndmt_original_file_data"
            :columns="ndmt_original_file_columns"
            paginated :per-page="paginationPerpage">
            </b-table>

            </b-tab-item>
			
			
			 <b-tab-item label="Substitutions" >
    <p>Substitutions are string replacements/substitutions that are processed for the original datasource list for each datasource, before the string similarity calculations are applied.</p>

                     <b-field grouped>
        <b-field label="Original String" >
            <b-input v-model="addNewSubstitutionOriginalString" type="text"></b-input>
        </b-field>
        <b-field label="Substituted String">
            <b-input v-model="addNewSubstitutionSubstitutionString" type="text"></b-input>
        </b-field>
        <b-field label="Add"> <b-button type="is-primary" @click="addNewSubstitution()"> 
            Add New
            </b-button>
             </b-field>
    </b-field>

  <div class="datatable"><b-table :data="substitutions_array" :loading="loading">
    <template slot-scope="props">
        <b-table-column searchable field="original_string" label="Original String">
            {{ props.row.original_string }}
        </b-table-column>
               <b-table-column searchable field="substituted_string" label="Substituted String">
            {{props.row.substituted_string }}
        </b-table-column>
               <b-table-column field="delete" label="Delete">
            <b-button label="Delete" type="is-dark" @click="deleteSubstitution(props.index)"/>
        </b-table-column>
    </template>
  </b-table></div>
		 </b-tab-item>
   
			
					 <b-tab-item label="Calculate Similarities" >
                          <p>Calculate similarities to find exact and similar datasource matches from original datasource list to change to new datasources in uploaded MSIB files. This tab also allows import and export of verification results/datasource changes.</p>
                            	       <b-field label="Algorithm">
            <b-select v-model="string_similarity_algorithm">
                <option value="jaccard">Jaccard</option>
            </b-select>
        </b-field>

                <b-field label="N-Grams" style="width:100px">
            <b-input v-model="n_grams" type="number"></b-input>
        </b-field>
        
                         <b-button  type="is-primary" @click="calculateStringSimilarities">Calculate String Similarities </b-button>

                         <br>
                         <br>

                           <b-field class="file is-primary" :class="{'has-name': !!importVerificationFile}">
        <b-upload v-model="importVerificationFile" class="file-label">
            <span class="file-cta">
                <b-icon class="file-icon" icon="upload"></b-icon>
                <span class="file-label">Select Verification File to Import</span>
            </span>
            <span class="file-name" v-if="importVerificationFile">
                {{ importVerificationFile.name }}
            </span>
        </b-upload>
    </b-field>

    
   <b-field grouped group-multiline>
               <p class="control"><b-button  label="Import Verification File" type="is-primary" @click="importVerificationFileFunction"></b-button></p>
                       <p class="control"> <b-button label="Export Verification File" type="is-dark" @click="exportVerificationFile"></b-button></p>
    </b-field>
   
		 </b-tab-item>
		 
		 
		 	 <b-tab-item label="Verification" >
    
                   <b-field grouped group-multiline>
               <p class="control">     <b-button label="Force Save (recommended)" type="is-dark" @click="saveVerfication"/></p>
                       <p class="control">    <b-button label="Toggle Edit Mode" type="is-dark" @click="verificationEditMode = !verificationEditMode"/></b-button></p>
                             <p class="control">   <b-button label="Reverify with MSIB files" type="is-dark" @click="reVerifyVerificationData"/></b-button></p>
             <p class="control">Verify and change new datasources. In edit mode, rows from left table are draggable to replace datasource in right table</p>
    </b-field>

<div class="datatable"  v-if="!verificationEditMode"><b-table :data="verification_datasources_data" :loading="loading" paginated :per-page="paginationPerpage">
    <template slot-scope="props">
               <b-table-column searchable sortable field="original_datasource" label="Original Datasource">
            {{props.row.original_datasource }}
        </b-table-column>
        <b-table-column searchable sortable field="best_similarity_datasource" label="New Datasource (best similarity datasource)">

    		<drop class="drop" @drop="handleDrop(props.index,props.row.original_datasource, ...arguments)"> <b> <b-input type="text"  @input="verificationCurrentDatasourceInputChange(props.row.original_datasource, ...arguments)"
            v-model="props.row.best_similarity_datasource"></b-input></b> </drop> 


        </b-table-column>
                <b-table-column searchable sortable field="best_similarity_result" label="Best Similarity Result">
            {{ props.row.best_similarity_result}}
        </b-table-column>
             
                        <b-table-column searchable  sortable field="verified" label="Verified">
            {{ props.row.verified }}
        </b-table-column>
    </template>
  </b-table></div>
 

  <div v-if="verificationEditMode">
       
                      
<div class="columns">
  <div class="column scrollable-table-column">
      <b-table :data="msibdatasources_data" paginated :per-page="paginationPerpage" narrowed> 
           <template slot-scope="props">  
           
        <b-table-column searchable sortable field="device" label="Device">    <drag class="drag" :transfer-data="props.row.datasource">{{ props.row.device }}</drag></b-table-column>
        <b-table-column searchable sortable field="datasource" label="Datasource">  <drag class="drag" :transfer-data="props.row.datasource"> <b>{{props.row.datasource}}</b></drag></b-table-column>
        <b-table-column searchable sortable field="description" label="Description">    <drag class="drag" :transfer-data="props.row.datasource">{{ props.row.description }}</drag></b-table-column>
   <b-table-column searchable sortable field="object_type" label="Object Type">    <drag class="drag" :transfer-data="props.row.datasource">{{ props.row.object_type }}</drag></b-table-column>
    <b-table-column searchable sortable field="object_instance" label="Object Instance">    <drag class="drag" :transfer-data="props.row.datasource">{{ props.row.object_instance }}</drag></b-table-column>
 
    </template>
      </b-table>
  </div>
  <div class="column scrollable-table-column">
   <div class="datatable"><b-table :data="verification_datasources_data" :loading="loading" paginated :per-page="paginationPerpage" narrowed>
    <template slot-scope="props">
               <b-table-column searchable sortable field="original_datasource" label="Original Datasource">
         <drop class="drop" @drop="handleDrop(props.index,props.row.original_datasource, ...arguments)">  {{props.row.original_datasource }}</drop>
        </b-table-column>
        <b-table-column searchable sortable field="best_similarity_datasource" label="New Datasource (best similarity datasource)">
 <!--
    	<drag class="drag" :transfer-data="props.row.best_similarity_datasource">  <b-input type="text"  v-model="props.row.best_similarity_datasource"></b-input>  </drag>
 -->
    		<drop class="drop" @drop="handleDrop(props.index,props.row.original_datasource, ...arguments)"> <b> <b-input type="text"  @input="verificationCurrentDatasourceInputChange(props.row.original_datasource, ...arguments)"
            v-model="props.row.best_similarity_datasource"></b-input> </b></drop> 
        </b-table-column>
                <b-table-column searchable sortable field="best_similarity_result" label="Best Similarity Result">
          <drop class="drop" @drop="handleDrop(props.index,props.row.original_datasource, ...arguments)">  {{ props.row.best_similarity_result}}</drop>
        </b-table-column>     
                        <b-table-column searchable sortable field="verified" label="Verified">
           <drop class="drop" @drop="handleDrop(props.index,props.row.original_datasource, ...arguments)"> {{ props.row.verified }}</drop>
        </b-table-column>

    </template>
  </b-table></div>
  </div>
</div>
      </div>
		 </b-tab-item>
		 
		 
		 	 <b-tab-item label="Generate NDMT Files" >
                   <p>Generates new NDMT files with only modified datasources to import into NDMT. Generating file with only temporary datasources is also available for datasource switching. </p>
                
                    
   <b-field grouped group-multiline>
               <p class="control"><b-button  label="Generate NDMT Files" type="is-primary" @click="generateNDMTModifiedFile"></b-button></p>
                       <p class="control"> <b-button label="Generate NDMT Files (Dummy temporary datasources)" type="is-dark" @click="generateNDMTModifiedFileTemporary"></b-button></p>
    </b-field>
                		 </b-tab-item>

		 	 	 <b-tab-item label="Generate MSIB Files" > 		 
  <p>Generates culled MSIB files from all files uploaded in the MSIB Original Files tab. 
      Currently uses uploaded NDMT Original File and all new datasources in the Verification Tab to decide which points in MSIB files to keep.   
          Also can generate missing NDMT datasources from MSIB files, using NDMT datasoures and new datasources from Vrification tab</p>

                       
             <b-field grouped group-multiline>
               <p class="control"><b-button type="is-primary" label="Generate MSIB Files" @click="generateMSIBModifiedFiles"></b-button></p>
                       <p class="control">   <b-button type="is-primary" label="Generate Missing NDMT Datasources from MSIB Files" @click="generateMissingDatasourcesFromMSIBFIles"></b-button></p>
    </b-field>      
		 </b-tab-item>
        </b-tabs>
		

</div>
</section>
 </div>
</template>

<script>
import { Drag, Drop } from 'vue-drag-drop';
import NavbarComponent from '@/components/NavbarComponent.vue'
import moment from 'moment-timezone';
import _ from 'lodash';
import { saveAs } from 'file-saver';
export default {
  name: "NavigatorDatasourcesOverviewDashboard",
  components: {NavbarComponent, 
               Drag, Drop},
  data () {
    return {
      loading: false,
	  activeTab: 0,
      project_name: "",
	  dropFiles_originaldatasources: [],
	  dropFiles_msibdatasources: [],
	  dropFiles_ndmt_original_file: [],
	  string_similarity_algorithm: "jaccard",
	  n_grams: 1,
	  substitutions_array: [],
	  originaldatasources_data: [],
      originaldatasourceFileType: "meter_setup_xlsx", //meter_setup xlsx or csv 
      originaldatasources_columns:[{field:"datasource", label: "Datasource", searchable: true, sortable: true}],
	  msibdatasources_data: [],
      NDMT_Data_loaded_flag:false,
      msib_original_files: [],
      ndmt_original_file:[],
      ndmt_original_file_info:[],
      ndmt_original_file_data:[],
      ndmt_original_file_columns:[{field:"MeterName", label: "MeterName", searchable: true, sortable: true},
      {field:"Datasource", label: "Datasource", searchable: true, sortable: true},
      {field:"NodeID", label: "NodeID", searchable: true, sortable: true},
      {field:"NodeLocation", label: "NodeLocation", searchable: true, sortable: true},
    {field:"Medium", label: "Medium", searchable: true, sortable: true},
     {field:"ReportGroup", label: "ReportGroup", searchable: true, sortable: true},
      {field:"UOM", label: "UOM", searchable: true, sortable: true},
       {field:"MeterId", label: "MeterId", searchable: true, sortable: true},],

      msibdatasources_columns:[
            {field:"device", label: "Device", searchable: true, sortable: true},
          {field:"datasource", label: "Datasource", searchable: true, sortable: true},
      {field:"description", label: "Description", searchable: true, sortable: true},
      {field:"object_type", label: "Object Type", searchable: true, sortable: true},
      {field:"object_instance", label: "Object Instance", searchable: true, sortable: true}]
    ,
      msibdatasourcesFileType: "EDE-unedited", //EDE or Discovery
        importVerificationFile:[],
	  verification_datasources_data: [],
      substitutions_array: [],
      addNewSubstitutionOriginalString:"",
      addNewSubstitutionSubstitutionString:"",
      filteredMSIBsearch:"",
      verificationEditMode: false,
      paginationPerpage: 50,
	  
      
    }
  },

      computed: {
        filteredMSIBDatasources() {
            return this.msibdatasources_data.filter(option => {
                return (
                    option.datasource
                        .toString()
                        .toLowerCase()
                        .indexOf(this.filteredMSIBsearch.toLowerCase()) >= 0
                )
            })
        }
    },

  methods: {
      handleDrop(index,original_datasource,data) {
                let update_index = this.verification_datasources_data.findIndex(item => item.original_datasource == original_datasource)
                this.verification_datasources_data[update_index].best_similarity_datasource = data
                 this.verification_datasources_data[update_index].verified = "false - changed"
                 this.verification_datasources_data[update_index].best_similarity_result = ""
                this.updateVerificationDataToBackend(this.verification_datasources_data[update_index])
			},


        verificationCurrentDatasourceInputChange: _.debounce(async function(original_datsource, input_string) {
             let update_index = this.verification_datasources_data.findIndex(item => item.original_datasource == original_datsource)
                this.verification_datasources_data[update_index].best_similarity_datasource = input_string
                this.verification_datasources_data[update_index].verified = "false - changed"
                 this.verification_datasources_data[update_index].best_similarity_result = ""              
                this.updateVerificationDataToBackend(this.verification_datasources_data[update_index])
    },1000),



      updateVerificationDataToBackend(data){
             this.$axios({
                            method: 'POST',
                            url: this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/update_verification_data",
                        
                            data: {
                                'data': data 
                            },
                            headers: {
                                'content-type': 'application/json',
                                'Authorization': this.$store.getters.oidcIdToken
                            }
                        })
                        .then((response) => {
                            console.log(response)
                        }).catch((error) => {
                        this.loading=false;
                        this.$buefy.toast.open({message:'Something went wrong!', type:'is-danger'})
                            console.log(error);
                        });

        
      },
	   deleteDropFile(index) {
				this.dropFiles_msibdatasources.splice(index, 1)
				},
				
				
	
		async uploadOriginalDatasources(){

                this.loading=true;
                let options_json= {}
                let formData = new FormData();
                console.log(this.dropFiles_originaldatasources)
                let url =  this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/original_datasources"
                let auth_token = this.$store.getters.oidcIdToken
                formData.append("file", this.dropFiles_originaldatasources)
                formData.append("filetype", this.originaldatasourceFileType)
             await this.$axios.post(url,formData, {headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': this.$store.getters.oidcIdToken}})
                        .then((response) => {
                            console.log(response)
                            this.getOriginalDatasources()
                        }).catch((error) => {
                        this.loading=false;
                        this.$buefy.toast.open({message:'Something went wrong!', type:'is-danger'})
                            console.log(error);
                        });
		},
		
		async getOriginalDatasources(){
            this.loading=true;
            const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/original_datasources"
            await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.originaldatasources_data = response.data.original_datasources
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
		},
		
		async deleteOriginalDatasources(){
                          this.loading=true;
             const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/original_datasources"
            await this.$axios({ method: 'delete',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded','Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.loading=false;
                this.originaldatasources_data=[]
            }).catch(error => { 
             this.loading=false;
              this.savedMetersDeleteActive="Error. Something went wrong. Could not delete data."
            console.log(error)             
            });  
       
		},
		
		async uploadMSIBdatasources(){
            
                this.loading=true;
                let options_json= {}
                let formData = new FormData();
                console.log(this.dropFiles_originaldatasources)
                let url =  this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/msib_datasources"
                let auth_token = this.$store.getters.oidcIdToken
                this.dropFiles_msibdatasources.forEach(file => {
                       formData.append("files", file)
                });

                formData.append("filetype", this.msibdatasourcesFileType)
             await this.$axios.post(url,formData, {headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': this.$store.getters.oidcIdToken}})
                        .then((response) => {
                            console.log(response)
                            this.getMSIBdatasources()
                        }).catch((error) => {
                        this.loading=false;
                        this.$buefy.toast.open({message:'Something went wrong!', type:'is-danger'})
                            console.log(error);
                        });
		},
		
		async getMSIBdatasources(){
            this.loading=true;
            const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/msib_datasources"
            await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.msibdatasources_data = response.data.msib_datasources
                this.msib_original_files = response.data.msib_original_files
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
		},
		
		async deleteMSIBdatasources(){
              this.loading=true;
             const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/msib_datasources"
            await this.$axios({ method: 'delete',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded','Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.loading=false;
                this.msibdatasources_data=[]
                this.msib_original_files=[]
            }).catch(error => { 
             this.loading=false;
              this.savedMetersDeleteActive="Error. Something went wrong. Could not delete data."
            console.log(error)             
            });  
            
		},
		
		async uploadNDMTOriginalFile(){
                 this.loading=true;
                let options_json= {}
                let formData = new FormData();
                console.log(this.dropFiles_originaldatasources)
                let url =  this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/ndmt_original_file"
                let auth_token = this.$store.getters.oidcIdToken
                formData.append("file", this.dropFiles_ndmt_original_file)
             await this.$axios.post(url,formData, {headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': this.$store.getters.oidcIdToken}})
                        .then((response) => {
                            console.log(response)
                            this.getNDMTOriginalFile()
                        }).catch((error) => {
                        this.loading=false;
                        this.$buefy.toast.open({message:'Something went wrong!', type:'is-danger'})
                            console.log(error);
                        });
		},
		
		async getNDMTOriginalFile(){
               this.loading=true;
            const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/ndmt_original_file"
            await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.ndmt_original_file_data = response.data.data
                this.ndmt_original_file_info = response.data.ndmt_original_file
                 this.loading=false;
                 this.NDMT_Data_loaded_flag = true;
            }).catch(error => { 
                this.NDMT_Data_loaded_flag=false;
                 this.loading=false;
            console.log(error)             
            });  
		},
		
		async deleteNDMTOriginalFile(){
            this.loading=true;
             const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/ndmt_original_file"
            await this.$axios({ method: 'delete',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded','Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.loading=false;
                this.ndmt_original_file_info={}
                this.ndmt_original_file_data=[]
            }).catch(error => { 
             this.loading=false;
              this.savedMetersDeleteActive="Error. Something went wrong. Could not delete data."
            console.log(error)             
            });  
            
		},
		
		async calculateStringSimilarities(){
            this.loading=true
            await this.$axios({
                            method: 'POST',
                            url: this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/calculate_string_similarities",
                        
                            data: {
                                'string_similarity_algorithm': this.string_similarity_algorithm,
                                'n_grams':  this.n_grams
                
                            },
                            headers: {
                                'content-type': 'application/json',
                                'Authorization': this.$store.getters.oidcIdToken
                            }
                        })
                        .then((response) => {
                            console.log(response)
                            this.loading=false;
                            this.getVerificationData();

                        }).catch((error) => {
                        this.loading=false;
                        this.$buefy.toast.open({message:'Something went wrong!', type:'is-danger'})
                            console.log(error);
                        });

            
		},

        async importVerificationFileFunction(){
                  this.loading=true;
                let options_json= {}
                let formData = new FormData();
                console.log(this.dropFiles_originaldatasources)
                let url =  this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/import_verification_file"
                let auth_token = this.$store.getters.oidcIdToken
                formData.append("file", this.importVerificationFile)
             await this.$axios.post(url,formData, {headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': this.$store.getters.oidcIdToken}})
                        .then((response) => {
                            console.log(response)
                            this.$buefy.toast.open({message:'Succesfully Imported Verification Data!'})
                            this.getVerificationData();
                        }).catch((error) => {
                        this.loading=false;
                        this.$buefy.toast.open({message:'Something went wrong!', type:'is-danger'})
                            console.log(error);
                        });

        },

        async exportVerificationFile(){
                    this.loading=true;   
            console.log("Time to save data to a CSV!");
            
            let csvData =''; 
            let separator = ',';
            let newline = '\n';
            let BOM = "\uFEFF";
            let rowHeaderArray = [];

            let meterDataCopy = this.verification_datasources_data

            //Get headers
                rowHeaderArray.push("Original Datasource");
                rowHeaderArray.push("New Datasource");
                rowHeaderArray.push("Best Similarity Result");
                rowHeaderArray.push("Verified")

            let rowHeaders = rowHeaderArray.join(separator)
            csvData += rowHeaders + newline;
            
            //for each meter
            meterDataCopy.forEach((meter)=>{
          
                     let rowArray = [];
                    rowArray.push(meter.original_datasource)  
                    rowArray.push(meter.best_similarity_datasource)  
                    rowArray.push(meter.best_similarity_result);  
                    rowArray.push(meter.verified)  
                   let row = rowArray.join(',');
                    csvData += row + newline;
               
            });
                  
        //SaveAsFile("\uFEFF" + csvData,"filename.csv","text/csv;charset=utf-8");
           let blob = new Blob([BOM + csvData],  { type: "text/csv;charset=utf-8" });
		   	var FileSaver = require('file-saver');
            saveAs(blob, "verificationMeterData"+moment().format('YYYY-MM-DD_HH_mm_ss')+".csv");
            this.loading=false;   
               this.$buefy.toast.open('Finished Exporting Data!')
		       console.log("Finished Saving Data!");	
        },
        
        async getVerificationData(){
               this.loading=true;
            const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/verification_datasources"
            await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.verification_datasources_data = response.data.verification_datasources
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
            
        },
		saveVerfication(){
               this.loading=true
             this.$axios({
                            method: 'POST',
                            url: this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/save_verification_data",
                        
                            data: {
                                'data': this.verification_datasources_data 
                            },
                            headers: {
                                'content-type': 'application/json',
                                'Authorization': this.$store.getters.oidcIdToken
                            }
                        })
                        .then((response) => {
                            console.log(response)
                              this.$buefy.toast.open({message:'Saved Data!'})
                            this.loading=false;
                        }).catch((error) => {
                        this.loading=false;
                        this.$buefy.toast.open({message:'Something went wrong!', type:'is-danger'})
                            console.log(error);
                        });

		},
		
		async addNewSubstitution(){
            this.substitutions_array.push({"original_string":this.addNewSubstitutionOriginalString, "substituted_string": this.addNewSubstitutionSubstitutionString})
            this.addNewSubstitutionOriginalString = ""
            this.addNewSubstitutionSubstitutionString = ""
            this.saveSubstitutions()
		},
		
		deleteSubstitution(index){
           this.substitutions_array.splice(index, 1)
           this.saveSubstitutions()
		},
		
		async saveSubstitutions(){
            this.loading=true
            await this.$axios({
                            method: 'POST',
                            url: this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/substitutions",
                        
                            data: {
                                'substitutions': this.substitutions_array,    
                            },
                            headers: {
                                'content-type': 'application/json',
                                'Authorization': this.$store.getters.oidcIdToken
                            }
                        })
                        .then((response) => {
                            console.log(response)
                            this.loading=false;
                        }).catch((error) => {
                        this.loading=false;
                        this.$buefy.toast.open({message:'Something went wrong!', type:'is-danger'})
                            console.log(error);
                        });

		},

        async getSubstitutions(){
               this.loading=true;
            const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/substitutions"
            await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.substitutions_array = response.data.substitutions
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
            

        },
		
		async generateNDMTModifiedFile(){
             this.loading=true;
            const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/generate_modified_ndmt_file"
            await this.$axios({ method: 'POST',url: url,responseType: 'blob',headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(res => {
                let data = res.data;
                const blob = new Blob([data], { type: 'application/xlsx' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'NDMT_modified_file_'+moment().format('YYYY_MM_DD')+'.xlsx'
                link.click()
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
		},
		
		async generateNDMTModifiedFileTemporary(){
                    this.loading=true;
            const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/generate_modified_ndmt_file_temporary"
            await this.$axios({ method: 'POST',url: url,responseType: 'blob',headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(res => {
                let data = res.data;
                const blob = new Blob([data], { type: 'application/xlsx' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'NDMT_modified_file_temporary_datasources_'+moment().format('YYYY_MM_DD')+'.xlsx'
                link.click()
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
		},

			async generateMissingDatasourcesFromMSIBFIles(){
                    this.loading=true;
            const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/generate_missing_datasources_from_msib_files"
            await this.$axios({ method: 'POST',url: url,responseType: 'blob',headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(res => {
                let data = res.data;
                const blob = new Blob([data], { type: 'application/xlsx' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'Missing_Datasources_from_MSIB_Files_'+moment().format('YYYY_MM_DD')+'.xlsx'
                link.click()
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
		},

		async generateMSIBModifiedFiles(){
                this.loading=true;
            const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id + "/generate_modified_msib_files"
            let data = {
                "datasources": "NDMT Original File and Verified New Datasources"
            }
            await this.$axios({ method: 'POST',url: url,responseType: 'blob', data:data,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(res => {
                let data = res.data;
                const blob = new Blob([data], { type: 'application/zip' })
                let link = document.createElement('a')
                link.href = window.URL.createObjectURL(blob)
                link.download = 'MSIB_modified_files_'+moment().format('YYYY_MM_DD')+'.zip'
                link.click()
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
            console.log(error)             
            });  
		},

        async loadInitialData(){
                  this.loading=true;
            const url = this.$store.getters.apiurl + "datasource_project/" + this.$route.params.id
            await this.$axios({ method: 'get',url: url,headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded', 'Authorization': this.$store.getters.oidcIdToken},
            }).then(response => {
                this.project_name = response.data.name
                this.originaldatasources_data = response.data.original_datasources
                this.msibdatasources_data = response.data.msib_datasources
                this.msib_original_files = response.data.msib_original_files
                this.verification_datasources_data = response.data.verification_datasources
                this.substitutions_array = response.data.substitutions
      
                 this.loading=false;
            }).catch(error => { 
                 this.loading=false;
             console.log(error)      
         })
        },

        onTabChange (index) {
            if (index == 1){
             
            }else if (index == 2) {
                if (this.NDMT_Data_loaded_flag == false){
            this.getNDMTOriginalFile();
                }
            }
        },

        reVerifyVerificationData(){
            this.loading = true;
            
            let msib_datasources_set = new Set()
            this.msibdatasources_data.forEach((record)=>{
            msib_datasources_set.add(record.datasource)
            })

            this.verification_datasources_data.forEach((record)=>{
                if (msib_datasources_set.has(record.best_similarity_datasource)){
                    record.verified = true
                }
                else{
                      record.verified = false
                }
            })
            this.loading = false;
            this.saveVerfication()
        }

		
		
		
		
  },
  created(){
  
  },
  mounted() {
      this.loadInitialData()

  },

watch: {
    /*
    // whenever question changes, this function will run
    importVerificationFile: function () {
        this.importVerificationFileFunction();
    }
    */
  },
}
</script>

<style scoped>
.scrollable-table-column{
height: calc(100vh - 170px);
overflow-y: auto;
overflow-x: auto;
}
</style>
